export enum ImportStatus {
  new = 0,
  update = 1,
  replace = 2,
}
